import UIComponent from '../../common/UIComponent';
import './index.css';

export default class Barrage extends UIComponent {
  constructor(elementId, interfaces) {
    super(interfaces);
    this.elementId = elementId;
    this.interfaces = interfaces;

    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.barrageComponent.bind(this),
      false
    );
    this.init();
    // this.flg = true;
  }

  init() {
    this.brarageComponent = document.createElement('div');
    this.brarageComponent.setAttribute('class', 'h5vhallPlayer-brarage-component');

    this.brarageBtn = document.createElement('span');
    this.brarageBtn.setAttribute(
      'class',
      'h5vhallPlayer-brarage-btn vh-player-iconfont vh-player-line-player-barrageon'
    );
    this.brarageBtn.onclick = this.handleBtnClick.bind(this);

    this.verticalSliderPopup = document.createElement('div');
    this.verticalSliderPopup.setAttribute('class', 'h5vhallPlayer-brarage-popup');

    this.brarageComponent.appendChild(this.brarageBtn);
    this.insertElement(this.elementId, this.brarageComponent);
  }

  handleBtnClick() {
    this.landscape = this.elementId.querySelector('.h5vhallPlayer-brarage-component-Landscape');
    if (this.brarageBtn.classList.contains('vh-player-line-player-barrageoff')) {
      // this.flg = true;
      this.brarageBtn.classList.add('vh-player-line-player-barrageon');
      this.brarageBtn.classList.remove('vh-player-line-player-barrageoff');
      this.interfaces.openBarrage();
      if (this.landscape && (window.orientation == 90 || window.orientation == -90)) {
        this.landscape.style.display = 'block';
      }
      // this.verticalSliderPopup.style.display = 'block';
    } else {
      // this.flg = false;
      this.brarageBtn.classList.remove('vh-player-line-player-barrageon');
      this.brarageBtn.classList.add('vh-player-line-player-barrageoff');
      this.interfaces.closeBarrage();
      if (this.landscape) {
        this.landscape.style.display = 'none';
      }

      // this.verticalSliderPopup.style.display = 'none';
    }
  }

  barrageComponent() {
    this.landscape = this.elementId.querySelector('.h5vhallPlayer-brarage-component-Landscape');
    if (window.orientation == 180 || window.orientation == 0) {
      if (this.landscape) {
        this.landscape.style.display = 'none';
      }
      // alert("竖屏状态！")
    }
    if (window.orientation == 90 || window.orientation == -90) {
      if (this.landscape && this.interfaces.barrageState()) {
        this.landscape.style.display = 'block';
      }
      // alert("横屏状态！")
    }
  }
}
